import { isSet } from '../utils/isSet';

class Video {
    constructor (domNode) {
        this.domNode = domNode;
        this.poster = domNode.querySelector('.video__poster');
        this.videoElm = domNode.querySelector('.video__target');
        this.videoSource = this.videoElm.dataset.src;
        this.play = domNode.querySelector('.video__play');

        if(isSet(this.play)) this.play.addEventListener('click', this.onPlayClick.bind(this));

        if(isSet(this.videoElm)) this.videoElm.addEventListener('play', this.onVideoPlay.bind(this));
        if(isSet(this.videoElm)) this.videoElm.addEventListener('pause', this.onVideoPause.bind(this));

        this.init();
    }

    init(){
        this.domNode.classList.add('has-initialised');
    }

    onPlayClick(){
        if(isSet(this.poster)) this.poster.remove();
        if(this.videoElm.paused !== true){
            this.videoElm.pause();
        } else{
            this.videoElm.play();
        }
    }

    onVideoPlay(){
        this.domNode.classList.add('is-playing');
        this.domNode.classList.remove('is-paused');
    }

    onVideoPause(){
        this.domNode.classList.add('is-paused');
        this.domNode.classList.remove('is-playing');
    }
}

exports.Video = Video